export default "<p>base-inventory works!</p>\n"